//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import axios from 'axios';
Vue.use(DatePickerPlugin);
export default {
    props: ['message', 'imgsrc', 'setdate', 'allowplanner', 'getstartedsect', 'getstarteddiff', 'getstartedtype', 'selected', 'userevents'],
    methods:{
        onFocus: function(args){
            // console.log(this.message);
            this.$refs.dateObj.show();
        },
        onOpen: function (event) { 
            var btn = document.getElementById(this.message); 
            event.popup.relateTo = btn; 
            event.popup.position = { X: 'left', Y: 'top' }; 
            event.popup.dataBind(); 
            event.popup.refreshPosition(btn, true); 
        },
        onClose: function(args){
            // console.log('here');
        },
        onChange: function(args){
            this.dateval = new Date(this.setdate);
            let v = this;
            var data = new FormData();
            data.append('selected_date', args.event.target.title);
            data.append('marketing_item', this.message);
            data.append('get_started', 1);
            data.append('get_started_sect', this.getstartedsect);
            data.append('get_started_type', this.getstartedtype);
            data.append('action', 'setuserevent');
            this.notice = '<h4><span>Added to planner.</span></h4>';
            setTimeout(function() {
                v.notice = '';
            }, 3000);

            axios
                .post(ajax_object.ajax_url, data)
                .then(response => {
                   this.setError(response.data.errorsect, response.data.errordiff , response.data.errortype);
                    this.dateval = new Date();
                    this.curselected.push(this.message);
                    this.curuserevents.push(response.data.usereventid);
                    this.backdoor++;
                    setTimeout(function() {
                        v.notice = '';
                    }, 2000);
                });
        },
        removeFromSelected: function(){
            let v = this;
            let id = this.message;
            let arr = this.curselected;
            let index = arr.indexOf(id);
            if (index > -1) {
                arr.splice(index, 1);
            }

            this.notice = '<h4><span>Removed from planner.</span></h4>';
            var data = new FormData();
            data.append('item', this.curuserevents[index]);
            data.append('sect', this.getstartedsect);
            data.append('type', this.getstartedtype);
            data.append('action', 'removegetstarteditem');

            axios
                .post(ajax_object.ajax_url, data)
                .then(response => {
                    console.log(response.data)
                   this.setError(this.getstartedsect, response.data.errordiff , this.getstartedtype);
                   this.backdoor++;
                    setTimeout(function() {
                        v.notice = '';
                    }, 2000);
                });
        },
        setError: function(sect, diff, type) {
            var elem = document.querySelector('#getstartedprogress');
            if (elem) {
                if (diff) {
                    elem.innerHTML = '<div class="woocommerce-message error" role="alert"> <span> Please select ' + diff + ' more ' + sect + ' for your ' + type + ' plan. </span> </div>';
                } else {
                    elem.innerHTML = '';                
                }
            }
        }
    },
    computed: {
        addMessage: function () {
            let label = '+ Add to planner';
            if (this.curselected.includes(this.message)) {
                label = '- Remove from planner';
            }
            return label;
        },
        setVisible: function () {
            let visible = 'itemcontrols';
            if (this.curselected.includes(this.message)) {
                visible = 'itemcontrols visible';
            }
            return visible;
        },
        inSelected: function (arg) {
            let selectedval = false;
            this.backdoor;
            if (this.curselected.includes(this.message)) {
                selectedval = true;
            }
            if (arg == 1) {
                selectedval = false;
            }
            return selectedval;
        }
    },
    data () {
        return{
            notice: '',
            backdoor: 0,
            dateval: new Date(this.setdate),
            value: 1,
            testvalue: 1,
            curselected: JSON.parse(this.selected),
            curuserevents: JSON.parse(this.userevents),
            curdiff: this.getstarteddiff,
        }
    },

    created: function () {
        // test status if user in Get Started
        var elem = document.querySelector('#getstartedprogress');

        if (elem) {
            if (this.getstarteddiff) {
                elem.innerHTML = '<div class="woocommerce-message error" role="alert"> <span> Please select ' + this.curdiff + ' more ' + this.getstartedsect + ' for your ' +  this.getstartedtype + ' plan. </span> </div>';
            }
        }
    },

    mounted() {
        this.backdoor++;
    },
}



// WEBPACK FOOTER //
// ./scripts/Addtoplannergs.vue